<template>
  <el-timeline-item
    :timestamp="createTime | convertToLabelFilter"
    placement="top"
  >
    <el-card>
      <h4 class="margin-bottom-10">
        <i class="fas fa-user color__silver"></i>
        {{ creatorName }}
      </h4>

      <slot name="historyHeader"></slot>

      <div class="style-fullWidth margin-top-10" v-if="!!comment">
        <p class="margin-top-5">
          <i class="fas fa-feather-alt color__silver"></i>
          {{ comment }}
        </p>
      </div>

      <div
        class="style-fullWidth margin-top-10 has-border__top"
        v-if="vbAttachments && vbAttachments.length"
      >
        <history-attachments-template-v2
          :vbAttachments="vbAttachments"
          @downloadFile="downloadFile"
        ></history-attachments-template-v2>
      </div>
    </el-card>
  </el-timeline-item>
</template>

<script>
import ActionLogAttachments from "../../doc-in/actionLogAttachments";
import dateFormatter from "../../../filters/dateFormatter";
import convertToLabelFilter from "../../../filters/convertToLabelFilter";
import buildAttachmentURL from "../../../filters/buildAttachmentURL";
import DocInReceiversInfo from "../../doc-in/doc-in-receivers-info";
import HistoryAttachmentsTemplateV2 from "./history-attachments-template-v2";

export default {
  name: "history-item-template",
  components: {
    HistoryAttachmentsTemplateV2,
    DocInReceiversInfo,
    ActionLogAttachments
  },
  props: ["createTime", "creatorName", "comment", "vbAttachments"],
  filters: {
    dateFormatter,
    convertToLabelFilter,
    buildAttachmentURL
  },
  created() {},
  methods: {
    downloadFile({ vbAttachment }) {
      this.$emit("downloadFile", { vbAttachment });
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/common/layout/history-item-template.vue